var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ribbon",class:`ribbon-${_vm.color}`},[_c('span',{staticClass:"rtl lang-fa"},[_vm._v(_vm._s(_vm.text))]),_c('div')])
}
var staticRenderFns = []

export { render, staticRenderFns }